import { Schema } from 'effect';
import { PolicyCoverage, PolicyRequired, PolicyType } from '../sitedata/policy.js';
import { RESERVED_SLUGS } from '../sitedata/postSlug.js';
import { SiteId } from './common.js';
/**
 * DTO schemas for the /admin/policies group: the write side of the site's
 * policies (terms and rules). See http/config.ts for conventions - a body is
 * stricter than the stored-document schema, every field required and bounded.
 *
 * A policy is split in two. Its metadata stays in siteData.policies, which
 * booking and checkout need before anything renders; its text is a page
 * document of kind 'policy' at sites/{site}/pages/{policyId}. One save writes
 * both, in one transaction. The text is html and sanitised on read (see
 * PageContent), so it is bounded here, not cleaned.
 */
export const PolicyTypeParams = Schema.Struct({
    siteId: SiteId,
    policyType: Schema.Enum(PolicyType)
});
export const OkResponse = Schema.Struct({ message: Schema.String });
/**
 * The policy id is also a document id in the pages collection, shared with
 * built-in pages and posts. Existing ids are uuids and 'tos-1', so this only
 * rules out what Firestore or the built-in pages would not accept.
 */
export const isValidPolicyId = (id) => id.length > 0 &&
    id.length <= 200 &&
    !id.includes('/') &&
    id !== '.' &&
    id !== '..' &&
    !/^__.*__$/.test(id) &&
    !RESERVED_SLUGS.has(id);
// --- PUT /admin/policies/:siteId/:policyType ---------------------------------
export const PolicyBody = Schema.Struct({
    id: Schema.String.pipe(Schema.check(Schema.isMaxLength(200))),
    title: Schema.Trim.pipe(Schema.check(Schema.isMaxLength(200))),
    order: Schema.Number,
    version: Schema.Trim.pipe(Schema.check(Schema.isMaxLength(50))),
    acceptanceRequired: Schema.Enum(PolicyRequired),
    items: Schema.Array(Schema.String.pipe(Schema.check(Schema.isMaxLength(200)))).pipe(Schema.check(Schema.isMaxLength(500))),
    coverage: Schema.Array(Schema.Enum(PolicyCoverage)).pipe(Schema.check(Schema.isMaxLength(10))),
    // The policy text as html. Left out, the stored text is kept: the page only
    // sends the text of policies it edited.
    // Well inside Firestore's 1 MiB document limit.
    body: Schema.optional(Schema.String.pipe(Schema.check(Schema.isMaxLength(500_000))))
});
/**
 * Every policy of one type, as the policy page shows them. Policies of that
 * type missing from the list are deleted; the other type is left alone.
 */
export const SavePoliciesBody = Schema.Struct({
    policies: Schema.Array(PolicyBody).pipe(Schema.check(Schema.isMaxLength(50)))
});
// --- problem ids --------------------------------------------------------------
/** Ids the admin UI maps to its own inline messages. */
export const PolicyProblem = {
    invalidId: 'problem.admin.policies.invalidid',
    duplicateId: 'problem.admin.policies.duplicateid',
    idTaken: 'problem.admin.policies.idtaken',
    siteNotFound: 'problem.admin.policies.sitenotfound'
};
//# sourceMappingURL=policies.js.map